<div class="card-view-primary-box app-scrollbar">
  <div class="header row align-items-center">
    <div class="col-11 d-flex align-items-end">
      <div class="col-12 d-flex align-items-center">
        <img src="{{ iconPath }}" alt="key icon" />

        <span class="count pr-10 pl-12">
          {{ 0 }}
        </span>

        <div class="title">
          {{ title }}
          <div class="day">{{ 'TODAY' | translate }}</div>
        </div>
      </div>
    </div>
    <hr class="col-12 divider" />
  </div>

  <div class="content position-relative">
    <div class="main-containter">
      <div class="text-center mb-4 mt-5">
        <h2 class="heading">{{ 'NO_DATA_TO_SHOW' | translate }}</h2>
      </div>
    </div>
  </div>

  <a
    class="view-all-btn d-flex justify-content-center align-items-center pointer-cursor"
  >
    <p class="mt-1 mb-0">&nbsp;&nbsp;</p>
  </a>
</div>
